import { render } from "./search-match-viewer.vue?vue&type=template&id=7708a766&ts=true"
import script from "./search-match-viewer.vue?vue&type=script&lang=ts"
export * from "./search-match-viewer.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__